import React, { createContext, useContext, useState, useCallback } from 'react';

const ScriptContext = createContext(null);

const STEPS = [
  { num: 1, label: '키워드 입력' },
  { num: 2, label: '분석 + 주제' },
  { num: 3, label: '가이드 설계' },
  { num: 4, label: '대본 생성' },
  { num: 5, label: '대본 편집' },
  { num: 6, label: '완성' },
];

export function ScriptProvider({ children }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [analysis, setAnalysis] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [outline, setOutline] = useState(null);
  const [guide, setGuide] = useState(null);
  const [bibleRefs, setBibleRefs] = useState([]);
  const [bibleContext, setBibleContext] = useState('');
  const [script, setScript] = useState(null);
  const [shortforms, setShortforms] = useState([]);
  const [savedId, setSavedId] = useState(null);

  const reset = () => {
    setCurrentStep(1);
    setKeyword('');
    setAnalysis(null);
    setSelectedTopic(null);
    setOutline(null);
    setGuide(null);
    setBibleRefs([]);
    setBibleContext('');
    setScript(null);
    setShortforms([]);
    setSavedId(null);
  };

  const loadSavedScript = useCallback((data) => {
    setKeyword(data.keyword || '');
    setSelectedTopic(data.topic || null);
    setOutline(data.outline || null);
    setGuide(data.guide || null);
    setScript(data.script || null);
    setShortforms(data.shortforms || []);
    setSavedId(data._id || null);
    setCurrentStep(5);
  }, []);

  return (
    <ScriptContext.Provider value={{
      STEPS,
      currentStep, setCurrentStep,
      keyword, setKeyword,
      analysis, setAnalysis,
      selectedTopic, setSelectedTopic,
      outline, setOutline,
      guide, setGuide,
      bibleRefs, setBibleRefs,
      bibleContext, setBibleContext,
      script, setScript,
      shortforms, setShortforms,
      savedId, setSavedId,
      reset,
      loadSavedScript,
    }}>
      {children}
    </ScriptContext.Provider>
  );
}

export function useScript() {
  const ctx = useContext(ScriptContext);
  if (!ctx) throw new Error('useScript must be used within ScriptProvider');
  return ctx;
}
